import type { HttpClient } from './http';

export interface EmailAccount {
  id: number;
  email: string;
  provider: 'gmail' | 'outlook' | 'generic';
  host: string;
  port: number;
  tls: boolean;
  createdAt: string;
  updatedAt: string;
}
export interface EmailAccountsApi {
  list(): Promise<EmailAccount[]>;
  get(id: number): Promise<EmailAccount>;
  delete(id: number): Promise<void>;
}

export function createEmailAccountsApi(http: HttpClient): EmailAccountsApi {
  return {
    list: () => http.get<EmailAccount[]>('/email-accounts/'),
    get: (id: number) => http.get<EmailAccount>(`/email-accounts/${id}`),
    delete: (id: number) => http.delete<void>(`/email-accounts/${id}/delete`),
  };
}
